<template>
  <div class="toolWorkProgress">
    <el-container  style="flex-direction: column;">
      <!-- <MachMonitor></MachMonitor> -->
      <NJNav></NJNav>
        <div class="charts-box">
          <div class="tab-box" style="text-align: center;">
            <div class="times" style="margin-bottom: 1vh;">
              <p>农机补贴机具各作业类型趋势图</p>
              <!-- <p>统计时间：截止到{{ getNowFormatDates() }}</p> -->
              <p>统计时间：{{ getFirstDayOfYear(new Date()) }}至{{ getNowFormatDates() }}</p>
              <!-- <p>统计时间：{{ getFirstDayOfYear(new Date()) }}至{{ getNowFormatDates() }}</p> -->
            </div>
             <span class="sub_title">*全国联网农机在本地区的作业趋势</span>
          </div>
          <div class="tab-boxs">
            <div class="tool_work_items">
              <div v-for="(item, i) in njNumList1" :class="[{ 'active': activeName == item.catThreeName },'nj_items'+item.icon, 'item_Num']" :key="i" @click="tabItemClick(item)">
                <div></div>
                <div class="nj_num_content">
                  <p class="nj_name">{{ item.catThreeName }}</p>
                  <p class="nj_num">{{ item.area }}<span class="nj_danwei">{{item.workUnit}}亩次</span></p>
                  <!-- <p class="nj_danwei">作业面积（亩次）</p> -->
                </div>
                <!-- <div>
                  <p class="nj_num2">{{ item.workArea }}</p>
                  <p class="nj_danwei">作业面积（亩次）</p>
                </div> -->
              </div>
            </div>
            <div class="select-block">
              <div id="workTrendChart"></div>
            </div>
          </div>
        </div>
    </el-container>
  </div>
</template>

<script>
// import "echarts/map/js/china.js";
import Api from "../../Serves/net-api.js";
import Http from "../../Serves/net-http.js";
// import MachMonitor from "./MachMonitor.vue";
import NJNav from '../Index/view/NJNav'

export default {
  name: "Monitor",
  components: { NJNav },
  data() {
    return {
      progressTitleClass: '',
      numsClass: '',
      myChart: "",
      activeName: "全部智联机具",
      cityName:
        this.$store.state.areaName === "全国"
          ? this.$store.state.areaName
          : this.$store.state.areaName,
      itemList: [],
      workType: "",
      // dateNumber: [],
      // dateList: [],
      trendList: [],
      njNumList: [],
      njNumList1:[]
    };
  },
  mounted() {
    this.init();
    this.getTrendData();
    this.statisticMachine();
  },
  methods: {
    init() {
      setTimeout(() => {
        this.$nextTick(() => {
          window.addEventListener("resize", () => {
            this.myChart.resize();
          });
        });
      });
    },
    statisticMachine() {
      let this_ = this;
      // var url = Http.test + '/homePageStatisByJSController/getCountNjNumByLocal'
      var url = Http.test + '/screenBuyNj/njNumAndWorkArea'
      Api.doPost(url, null, false, res => {
       let data = JSON.parse(JSON.stringify(res.result));
					data.forEach((item, index) => {
						item.area = this.$common.unitFormat(Number(item.area))[0];
						item.workUnit = this.$common.unitFormat(Number(res.result[index].area))[1];
					})
					this.njNumList1 = data
      })
    },
    timeFormat(date) {
      if (!date || typeof date === "string") {
        this.error("参数异常，请检查...");
      }
      var y = date.getFullYear(); // 年
      // this.yearValue = y
      var m = date.getMonth() + 1; // 月
      var d = date.getDate(); // 日
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 1 && d <= 9) {
        d = "0" + d;
      }
      // return y + "-" + m + "-" + d;
      return y + '年' + m + '月' + d + '日'
    },
    // 获取本年第一个月
    getFirstDayOfYear(date) {
      date.setDate(1);
      date.setMonth(0);
      return this.timeFormat(date);
    },
    // 获取当前日期
    getNowFormatDates() {
      var date = new Date();
      var seperator1 = "-";
      // var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      // var currentdate = year + seperator1 + month + seperator1 + strDate;
      var currentdate = month + '月' + strDate + '日'
      return currentdate;
    },
    tabItemClick(item) {
      this.activeName = item.catThreeName;
      // this.workType = item.catThreeCode;
      this.getTrendData(item.catThreeCode);
    },
    getTrendData(typeId) {
      var parmse = {
        catThreeCode: typeId === '' ? '' : typeId
      };
      var url = Http.test + "/trend/getWorkTrend";
      Api.doPost(url, parmse, false, res => {
        this.trendList = res.result.resultMap
        this.workchart();
      });
    },
    workchart() {
      this.myChart = this.$echarts.init(
        document.getElementById("workTrendChart")
      );
      var dateNumber = [];
      var dateList = [];
      this.trendList.forEach(item => {
        dateNumber.push(item.workArea);
        // dateList.push(item.workTime);
        dateList.push(item.workTime.slice(5));
        this.myChart = this.$echarts.init(
          document.getElementById("workTrendChart")
        );
      });
      var date = new Date();
      var month = date.getMonth()+1;
      this.myChart.setOption({
        // tooltip: {
        //   trigger: "item"
        // },
        // 新加
        // tooltip: {
        //   trigger: "axis"
        //   // axisPointer: {
        //   //   type: "cross",
        //   //   crossStyle: {
        //   //     color: "#999"
        //   //   }
        //   // }
        // },
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            var relVal = '<div class="tooltipBox"><span">'+params[0].name+'</span>';
            for(var i = 0, l = params.length; i < l; i++) {
              // let unit = params[i].seriesName == '作业面积未达标' ? '亩' : '台'
              relVal += '<br/> <span>' + params[i].marker+ params[i].seriesName + ' : ' + params[i].value +'亩</span>'
            }
            relVal +='</div>'
            return relVal
          }
        },
        grid: {
          top: '10%', // 距离容器上边界40像素
          bottom: dateNumber.length > 30 ? '15%' : '7%', // 距离容器下边界30像素
          left: 60,
          right: 40,
        },
        xAxis: {
          type: "category",
          data: dateList,
          // 新加
          axisPointer: {
            type: "shadow"
          },
          axisLabel: {
            color: "#A8ADCD",
            // interval: 0,
            rotate: dateNumber.length > 30 ? 30 : 0
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#dddddd"
            },
            width: 5
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: "value",
          name: '单位：亩',
          nameTextStyle: {
          	padding: [0,60, 0, 0],
            color: "#A8ADCD"
          },
          axisLabel: {
            show: true,
            color: "#A8ADCD",
            formatter: "{value}"
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#dddddd"
            },
            width: 5
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              width: 0.2,
              type: "dashed",
              color: "#e9e9e9"
            }
          }
        },
        dataZoom: [
          {
            type: "slider", //滑动条
            show: dateNumber.length > 30 ? true : false, //开启
            xAxisIndex: [0],
            left: "3.5%", //滑动条位置
            bottom: "4.5%",
            start: month <= 2 && month > 1 ? 40 : month <= 5 && month >= 3 ? 60 : month <= 9 && month >= 6 ? 80 : month <= 12 && month >= 10 ? 95 : 0, //初始化时，滑动条宽度开始标度
            end: 100 //初始化时，滑动条宽度结束标度
          },
          //X轴内置滑动
          {
            type: "inside", //内置滑动，随鼠标滚轮展示
            show: dateNumber.length > 30 ? true : false, //开启
            xAxisIndex: [0],
            start: month <= 2 && month > 1 ? 40 : month <= 5 && month >= 3 ? 60 : month <= 9 && month >= 6 ? 80 : month <= 12 && month >= 10 ? 95 : 0, //初始化时，滑动条宽度开始标度
            end: 100 //初始化时，滑动条宽度结束标度
          }
        ],
        series: [
          {
            // 新加
            name: "作业面积",
            data: dateNumber,
            type: "line",
            itemStyle: {
              normal: {
                color: "#2771DE", //改变折线点的颜色
                lineStyle: {
                  color: "#2771DE" //改变折线颜色
                }
              }
            }
          }
        ]
      })
    }
  }
};
</script>
<style scoped>
  /*里面的代码可以根据自己需求去进行更改*/
/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width:3px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
  -webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
  border-radius:10px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius:10px;
  background:#0A63C6;
  -webkit-box-shadow:inset006pxrgba(0,0,0,0.5);
}
	.tab-box {
		width: 98%;
		margin-left: 1%;
		/* margin-bottom: 10px; */
		/* margin-top: 20px; */
		/* display: flex; */
	}
	
.tab-boxs {
		width: 98%;
		margin-left: 1%;
		display: flex;
		/* background: #0B1640; */
		/* justify-content: space-between; */
	}
	.sub_title{
		font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFF600;

	}
.toolWorkProgress {
  width: 100%;
  height: 70vh;
}
#workTrendChart {
  width: 100%;
  height: 74vh;
  margin-left: 1%;
}
.tablist_item {
  width: 30%;
  display: flex;
  margin-top: -14px;
}

.charts-box {
  width: 98%;
  height: 83vh;
  background-image: url('/static/img/zuoyejindu-bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  margin-left: 1%;
  margin-top: 1vh;
}
.charts-box-top {
  padding: 20px;
  display: flex;
  justify-content: space-between;
}
.tablist_item {
  width: 40%;
  display: flex;
}

/* @media screen and (max-width: 1540px) {
 
  .charts-box {
    height: 90vh;
  }
} */

  .select-block{
    width: 90%;
    height: 75vh;
  }
/* @media screen and (max-width: 1540px) {
  .select-block-pro{
    width: 100%;
    height: 520px;
  }
  .select-block{
    width: 100%;
    height: 520px;
  }
} */
/*.nums {
  width: 50%;
  display: flex;
}
.item-nums {
  width: 30%;
  text-align: center;
}
.item-nums p{
  font-size: 0.8vw;
  color: #439BFF;
}
.item-nums p span{
  font-size: 1.3vw;
}*/
</style>



// WEBPACK FOOTER //
// src/components/TableList/ToolWorkTrend.vue